export const changeModulePermissionsReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_MODULE_PERMISSIONS":
      return action.payload.modulePermissions;
    default:
      return state;
  }
};
